import { TableCell } from "@mui/material";
import styled from "styled-components";

export const StyledTableCell = styled(TableCell)`
  && {
    border-bottom: ${({ theme }) => `1px solid ${theme.colors.border2}`};
    padding: 1rem;
  }
`;
